export default __webpack_public_path__ + "img/logmein-favicon.495f77f73450ba6feb8bbbb898bee11b.ico";